<template>
  <label
    class="sf-form-check"
    data-testid="sf-checkbox"
    :class="containerClass"
  >
    <slot name="left-side"> </slot>
    <input
      v-bind="$attrs"
      :checked="modelValue"
      type="checkbox"
      :disabled="disabled"
      @click="handleChange"
    />
    <span class="sf-form-check-content">
      <span class="sf-form-check-indicator" :class="indicatorClasses">
        <span
          v-if="indeterminate"
          class="sf-form-check-indeterminate-indicator"
        />
      </span>
    </span>
    <span v-if="label">{{ label }}</span>
    <slot name="right-side"> </slot>
  </label>
</template>
<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'SfCheckbox',
  inheritAttrs: false,
})

interface Props {
  disabled?: boolean
  display?: 'inline' | 'block'
  label?: string
  modelValue?: boolean
  indeterminate?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  display: 'inline',
  label: '',
})

const emit =
  defineEmits<{
    'update:modelValue': [boolean]
  }>()

const containerClass = computed(() => ({
  'sf-inline-block': props.display === 'block',
  'sf-level': props.display === 'inline',
}))

const indicatorClasses = computed(() => ({
  'sf-disabled': props.disabled,
}))

function handleChange(event: Event) {
  if (props.indeterminate) {
    event.preventDefault()
  }
  emit('update:modelValue', !props.modelValue)
}
</script>

<style lang="scss" scoped>
.sf-form-check {
  .sf-form-check-content .sf-form-check-indicator {
    position: relative;

    .sf-form-check-indeterminate-indicator {
      position: absolute;
      background-color: white;
      width: 5px;
      height: 1px;
      top: 8px;
      left: 6px;
    }
  }
}
</style>
